import { render, staticRenderFns } from "./RoommateProfileSection.vue?vue&type=template&id=3b4b2318&scoped=true&"
import script from "./RoommateProfileSection.vue?vue&type=script&lang=js&"
export * from "./RoommateProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./RoommateProfileSection.vue?vue&type=style&index=0&id=3b4b2318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b2318",
  null
  
)

export default component.exports